import { render } from "./QuestionDetail.vue?vue&type=template&id=077c5cb3&ts=true"
import script from "./QuestionDetail.vue?vue&type=script&lang=ts"
export * from "./QuestionDetail.vue?vue&type=script&lang=ts"

import "./QuestionDetail.vue?vue&type=style&index=0&id=077c5cb3&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__